'use client';

let clevertapInstance = null;
let isCleverTapInitialized = false;

export const initCleverTap = async () => {
    if (typeof window === 'undefined') return;

    if (!isCleverTapInitialized) {
        const clevertap = (await import('clevertap-web-sdk')).default;

        clevertap.spa = true;
        clevertap.setLogLevel(3);
        clevertap.init('RKW-8WZ-RK7Z', 'eu1'); // replace with actual account ID & region
        isCleverTapInitialized = true;
        clevertapInstance = clevertap;
    }

    return clevertapInstance;
};
